import { bodyFont } from '@microsoft/fast-components';
// FAST creates a few design tokens that are imported later on and not in the
// ThemeProvider, so we cannot override them from within the ThemeProvider.
// These tokens are defined here:
// https://github.com/microsoft/fast/blob/%40microsoft/fast-components_v2.30.6/packages/web-components/fast-components/src/design-tokens.ts
export const overrideDefaultStyles = () => {
    bodyFont.withDefault('var(--goto-font-family)');
};
